import ajax from '../utils/request'

const adsApi = {
  /********************************广告管理*********************************** */
  // 请求广告列表
  getAdList(params) {
    return ajax({
      url: '/ads/list',
      type: 'get',
      params: params
    })
  },
  // 新增广告
  addAds(params) {
    return ajax({
      url: '/ads/add',
      type: 'post',
      params: params
    })
  },
  // 编辑广告
  editAds(params) {
    return ajax({
      url: '/ads/update',
      type: 'post',
      params: params
    })
  },
  // 删除广告
  delAds(params) {
    return ajax({
      url: '/ads/del',
      type: 'delete',
      params: params
    })
  },
  // 请求点击日志列表
  getClickLog(params) {
    return ajax({
      url: '/log/ads',
      type: 'get',
      params: params
    })
  },
  /********************************公告管理*********************************** */
  // 请求公告列表
  getAnnouList(params) {
    return ajax({
      url: '/annou/list',
      type: 'get',
      params: params
    })
  },
  // 新增公告
  addAnnou(params) {
    return ajax({
      url: '/annou/add',
      type: 'post',
      params: params
    })
  },
  // 编辑公告
  editAnnou(params) {
    return ajax({
      url: '/annou/update',
      type: 'post',
      params: params
    })
  },
  // 删除公告
  delAnnou(params) {
    return ajax({
      url: '/annou/del',
      type: 'delete',
      params: params
    })
  },

}
export default adsApi
